<template>
    <div class="certificate-info c-font-md c-font-line-md c-font-color-main c-relative">
        <div class="cjw-card" v-if="requestStatus">
<!--            <div class="cjw-image-header c-flex c-border-bottom">-->
<!--                <img class="cjw-image" src="@/assets/cert_header.jpg" alt="">-->
<!--            </div>-->

            <div class="cjw-title c-border-bottom c-font-bold c-text-center">证书查询结果</div>

            <div class="cjw-content c-border-bottom c-flex">
                <img style="width: 100%" :src="certInfo.certPath" alt="" class="cjw-image">
            </div>

<!--            <div class="cjw-content c-border-bottom">-->
<!--                <div class="c-mgb-5">证书编号：{{ certInfo.certNo }}</div>-->
<!--                <div class="c-mgb-5">证书内容：</div>-->
<!--                <div class="c-mgb-5 c-text-indent">-->
<!--                    <span>聘请</span>-->
<!--                    <span class="c-mgr-5 c-mgl-5 c-font-bold ">{{ certInfo.expertName }}</span>-->
<!--                    <span>担任{{ certInfo.position }}。</span>-->
<!--                </div>-->
<!--                <div class="">-->
<!--                    <span>聘期：</span>-->
<!--                    <span class="">{{ certInfo.startTime }}</span>-->
<!--                    <span class="">至</span>-->
<!--                    <span class="">{{ certInfo.overTime }}</span>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="cjw-footer">-->
<!--                <span>颁布时间：</span>-->
<!--                <span>{{ certInfo.issueTime }}</span>-->
<!--            </div>-->

        </div>

        <div class="cjw-card c-absolute" v-else>
            <div class="c-text-center">{{ requestErrorMsg }}</div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'certificate-info',
    components: {},
    data() {
        return {
            // requestBaseUrl: 'https://test.ckeword.org.cn/api/cert',
            requestBaseUrl: 'https://cert.ckeword.org.cn/api/cert',
            certNo: '',
            certInfo: {},

            requestStatus: false,
            requestErrorMsg: '证书查询中...'
        }
    },
    mounted() {
        this.certNo = this.$route.query.certNo;
        // this.certNo = '8202603386';
        if(this.certNo) {
            this.handleGetCertInfo();
        }
    },
    methods: {
        handleGetCertInfo() {
            // 发送 POST 请求
            axios.post(`${this.requestBaseUrl}/query`, {
                certNo: this.certNo
            }).then((resp) => {
                // 请求成功
                if (resp.status === 200) {
                    // 业务逻辑成功
                    if (resp.data.code === 200) {
                        this.requestStatus = true;
                        this.certInfo = resp.data.data;
                    } else {
                        // 业务逻辑失败
                        this.requestStatus = false;
                        this.requestErrorMsg = resp.data.msg;
                    }
                } else {
                    // 请求失败
                    this.requestStatus = false;
                    this.requestErrorMsg = `查询失败：${resp.statusText}`;
                }

            }).catch((error) => {
                console.log(error);
                this.requestStatus = false;
                this.requestErrorMsg = `查询失败：${error.message}`;
            });
        }
    }
}
</script>

<style scoped lang="less">
.cjw-image-header {
    .cjw-image {
        width: 100%;
    }
}

.certificate-info {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    //height: 100vh;
    background-color: #f8f8f8;
}

.cjw-card {
    top: 50px;
    width: 90%;
    max-width: 480px;
    padding: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    box-shadow: 0 0 10px #e8e8e8;
    background-color: #fff;
}
.cjw-title {
    padding: 10px;
}
.cjw-content {
    padding: 10px 0;
}
.cjw-footer {
    padding-top: 10px;
}
</style>
